export const MIN_MORTGAGE_DURATION_IN_MONTHS = 60; // 5 years
export const MAX_MORTGAGE_DURATION_IN_MONTHS = 480; // 40 years
export const MIN_COMPARISON_PERIOD_LENGTH_IN_MONTHS = 6;
export const MAX_COMPARISON_PERIOD_LENGTH_IN_MONTHS = 60; // 5 years
export const MIN_AGE_ELIGIBLE_FOR_MORTGAGE_IN_MONTHS = 216; // 18 years
export const MAX_AGE_ELIGIBLE_FOR_MORTGAGE_IN_MONTHS = 900; // 75 years
export const MIN_INITIAL_MORTGAGE_AMOUNT = 1000;
export const MIN_INITIAL_INTEREST_RATE_NEW = 0.1;
export const MAX_INITIAL_INTEREST_RATE_NEW = 12;
export const MAX_CURRENCY_INPUT_LENGTH = 10;
export const MAX_LTV = 95; // 95%
